var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 66,
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.1754V21.0581C0 20.2254 0.36396 19.4268 1.01181 18.838C1.65967 18.2492 2.53834 17.9184 3.45455 17.9184C4.37075 17.9184 5.24943 18.2492 5.89728 18.838C6.54513 19.4268 6.90909 20.2254 6.90909 21.0581V46.1754C6.90909 47.0081 6.54513 47.8066 5.89728 48.3955C5.24943 48.9843 4.37075 49.315 3.45455 49.315C2.53834 49.315 1.65967 48.9843 1.01181 48.3955C0.36396 47.8066 0 47.0081 0 46.1754ZM24.1818 62.8603V3.13966C24.1818 2.30697 23.8179 1.50839 23.17 0.919586C22.5222 0.330785 21.6435 0 20.7273 0C19.8111 0 18.9324 0.330785 18.2845 0.919586C17.6367 1.50839 17.2727 2.30697 17.2727 3.13966V62.8603C17.2727 63.693 17.6367 64.4916 18.2845 65.0804C18.9324 65.6692 19.8111 66 20.7273 66C21.6435 66 22.5222 65.6692 23.17 65.0804C23.8179 64.4916 24.1818 63.693 24.1818 62.8603ZM41.4545 61.01L41.4545 8.08426C41.4545 7.25157 41.0905 6.45299 40.4426 5.86418C39.7948 5.27538 38.9161 4.9446 37.9999 4.9446C37.0837 4.9446 36.205 5.27538 35.5572 5.86418C34.9093 6.45299 34.5454 7.25157 34.5454 8.08426L34.5455 61.01C34.5455 61.8427 34.9094 62.6413 35.5573 63.2301C36.2051 63.8189 37.0838 64.1497 38 64.1497C38.9162 64.1497 39.7949 63.8189 40.4427 63.2301C41.0906 62.6413 41.4545 61.8427 41.4545 61.01ZM58.7273 58.734V8.49941C58.7273 7.66672 58.3633 6.86813 57.7155 6.27933C57.0676 5.69053 56.1889 5.35974 55.2727 5.35974C54.3565 5.35974 53.4778 5.69053 52.83 6.27933C52.1821 6.86813 51.8182 7.66672 51.8182 8.49941V58.734C51.8182 59.5667 52.1821 60.3653 52.83 60.9541C53.4778 61.5429 54.3565 61.8737 55.2727 61.8737C56.1889 61.8737 57.0676 61.5429 57.7155 60.9541C58.3633 60.3653 58.7273 59.5667 58.7273 58.734ZM72.5455 17.9184C71.6292 17.9184 70.7506 18.2492 70.1027 18.838C69.4549 19.4268 69.0909 20.2254 69.0909 21.0581V46.1754C69.0909 47.0081 69.4549 47.8066 70.1027 48.3955C70.7506 48.9843 71.6292 49.315 72.5455 49.315C73.4617 49.315 74.3403 48.9843 74.9882 48.3955C75.636 47.8066 76 47.0081 76 46.1754V21.0581C76 20.2254 75.636 19.4268 74.9882 18.838C74.3403 18.2492 73.4617 17.9184 72.5455 17.9184Z",
    fill: "url(#paint0_linear_314_1208)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_314_1208)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 18,
    fill: "#8D73F5",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_314_1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 5,
    height: 16,
    rx: 2.5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_314_1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 28,
    width: 5,
    height: 16,
    rx: 2.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_314_1208",
    x: -1.8,
    y: -1.8,
    width: 75.6,
    height: 75.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_314_1208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_314_1208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_314_1208",
    x: 25,
    y: 27,
    width: 13,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_1208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_1208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_314_1208",
    x: 33,
    y: 27,
    width: 13,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_1208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_1208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_314_1208",
    x1: 5.19057e-7,
    y1: 37.125,
    x2: 75.9972,
    y2: 38.6394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC5ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#655BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EDFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseAudio);
export default __webpack_public_path__ + "static/media/PauseAudio.f786196d6e04810e0a0bc94b42ba3bb6.svg";
export { ForwardRef as ReactComponent };